import { SVGProps } from 'react';

const Shredder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 22v-5m4 2v-2m0-15v4a2 2 0 0 0 2 2h4m-2 12v-3M2 13h20m-2 0V7l-5-5H6a2 2 0 0 0-2 2v9m2 7v-3"
    />
  </svg>
);
export default Shredder;
